export default {
    BACK_BUTTON: 'back',
    CANCEL_BUTTON: 'cancel',
};
